import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = "https://linxlegacyacademy.dk";

export default function Login() {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Tjekker login-status...");
  const navigate = useNavigate();

  useEffect(() => {
    async function checkLogin() {
      try {
        const res = await fetch(`${BACKEND_URL}/auth/user`, { credentials: "include" });
        const data = await res.json();

        if (data.status === "logged_in") {
          // Redirect til profil hvis allerede logget ind
          navigate("/profile-academy");
        } else {
          setMessage("🔒 Du er ikke logget ind endnu.");
        }
      } catch (err) {
        console.error("Fejl ved login-check:", err);
        setMessage("Kunne ikke hente login-status.");
      } finally {
        setLoading(false);
      }
    }
    checkLogin();
  }, [navigate]);

  if (loading) return <p style={{ textAlign: "center", marginTop: "6rem" }}>{message}</p>;

  return (
    <div style={{ textAlign: "center", marginTop: "6rem" }}>
      <h1>Login til Linx Legacy</h1>
      <button
        onClick={() => (window.location.href = `${BACKEND_URL}/auth/discord/login`)}
        style={{
          backgroundColor: "#5865F2",
          color: "#fff",
          padding: "0.8rem 1.4rem",
          borderRadius: "8px",
          border: "none",
          cursor: "pointer",
          marginTop: "1rem",
        }}
      >
        Login med Discord
      </button>
    </div>
  );
}